import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../actions'
import classNames from 'classnames'

class SideBar extends Component {
  render () {
    const {
      showSideBar,
      sideBarComponent,
      hideSideBar
    } = this.props

    const classes = {
      'side-bar-container': true,
      'side-bar-container-visible': showSideBar
    }

    let component = null

    if (typeof (sideBarComponent) === 'function') {
      component = sideBarComponent()
    }

    return (
      <div className='main-side-bar-container'>
        <div className={classNames(classes)}>
          <div
            className='side-bar'>
            {component}
          </div>
          <div
            className='side-bar-right-space'
            onClick={() => hideSideBar()}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  showSideBar: state.sideBar.showSideBar,
  sideBarComponent: state.sideBar.sideBarComponent
})

const withRedux = connect(mapStateToProps, actions)
export default withRedux(SideBar)
